import { useMatches } from '@tanstack/react-router';

export const useFullPath = () => {
  const matches = useMatches();
  const fullPath = matches[matches.length - 1].fullPath;
  const matchesPathes = matches.map((match) => match.fullPath);
  return { fullPath, matchesPathes };
};
